var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-intro" }, [
    _c("div", { staticClass: "home-intro__tab-head" }, [
      _c("ul", [
        _c(
          "li",
          {
            staticClass: "home-intro__tab",
            class: { "home-intro__tab--active": _vm.damenContentVisible },
            on: {
              click: function($event) {
                return _vm.openTabContent("damen")
              }
            }
          },
          [_vm._v("DAMEN")]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "home-intro__tab",
            class: { "home-intro__tab--active": _vm.herrenContentVisible },
            on: {
              click: function($event) {
                return _vm.openTabContent("herren")
              }
            }
          },
          [_vm._v("HERREN")]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "home-intro__tab",
            class: { "home-intro__tab--active": _vm.trendsContentVisible },
            on: {
              click: function($event) {
                return _vm.openTabContent("trends")
              }
            }
          },
          [_vm._v("TRENDS")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "home-intro__tab-content-wrapper" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.damenContentVisible,
              expression: "damenContentVisible"
            }
          ],
          ref: "damenContent",
          staticClass: "home-intro__tab-content home-intro__tab-content--damen"
        },
        _vm._l(_vm.slidestab1, function(cat) {
          return _c("div", { staticClass: "home-intro__tab-content-box" }, [
            _c(
              "a",
              {
                staticClass: "d-block",
                attrs: { href: cat.url, title: cat.name }
              },
              [
                cat.customImageUrl != "" &&
                typeof cat.customImageUrl != "undefined"
                  ? _c(
                      "div",
                      { staticClass: "home-intro__tab-content-img" },
                      [
                        _c("lazy-img", {
                          attrs: {
                            "picture-class": "",
                            "image-url": cat.customImageUrl,
                            alt: cat.name,
                            title: cat.name
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "home-intro__tab-content-img" },
                      [
                        _vm.getImageUrl(cat) != ""
                          ? _c("lazy-img", {
                              attrs: {
                                "picture-class": "",
                                "image-url": _vm.getImageUrl(cat),
                                alt: cat.name,
                                title: cat.name
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "home-intro__tab-content-txt" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(cat.name) +
                      "\n                    "
                  )
                ])
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.herrenContentVisible,
              expression: "herrenContentVisible"
            }
          ],
          ref: "herrenContent",
          staticClass: "home-intro__tab-content home-intro__tab-content--herren"
        },
        _vm._l(_vm.slidestab2, function(cat) {
          return _c("div", { staticClass: "home-intro__tab-content-box" }, [
            _c(
              "a",
              {
                staticClass: "d-block",
                attrs: { href: cat.url, title: cat.name }
              },
              [
                _c(
                  "div",
                  { staticClass: "home-intro__tab-content-img" },
                  [
                    _vm.getImageUrl(cat) != ""
                      ? _c("lazy-img", {
                          attrs: {
                            "picture-class": "",
                            "image-url": _vm.getImageUrl(cat),
                            alt: cat.name,
                            title: cat.name
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "home-intro__tab-content-txt" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(cat.name) +
                      "\n                    "
                  )
                ])
              ]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.trendsContentVisible,
              expression: "trendsContentVisible"
            }
          ],
          ref: "trendsContent",
          staticClass: "home-intro__tab-content home-intro__tab-content--trends"
        },
        _vm._l(_vm.slidestab3, function(cat) {
          return _c("div", { staticClass: "home-intro__tab-content-box" }, [
            _c(
              "a",
              {
                staticClass: "d-block",
                attrs: { href: cat.url, title: cat.name }
              },
              [
                _c(
                  "div",
                  { staticClass: "home-intro__tab-content-img" },
                  [
                    _vm.getImageUrl(cat) != ""
                      ? _c("lazy-img", {
                          attrs: {
                            "picture-class": "",
                            "image-url": _vm.getImageUrl(cat),
                            alt: cat.name,
                            title: cat.name
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "home-intro__tab-content-txt" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(cat.name) +
                      "\n                    "
                  )
                ])
              ]
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }